import { SET_PROJECT, SET_SCROLL } from "../types/types";

export const setscroll = (state = false, action) => {
    switch(action.type){
        case SET_SCROLL:
            return action.scrollstate;
        default:
            return state;
    }
}

export const projectState = {
  _id: "",
  title: "",
  published: false,
  link: "",
  description: [],
  image: "",
  gallery: [],
  categories: [],
  reposed: false,
  repository: "none",
  projectID: "",
  platforms: []
}

export const setproject = (state = projectState, action) => {
    switch(action.type){
        case SET_PROJECT:
            return action.initialproject;
        default:
            return state;
    }
}